export const SITE_URL = 'https://typeclicktests.com';
export const SITE_NAME = 'Type Click Tests';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.svg`;

export const buildCanonicalUrl = (path = '/') => {
  if (!path || path === '/') return `${SITE_URL}/`;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
